//#region Angular Imports

import { StateService, StateProvider } from '@uirouter/angularjs'
import 'angular-gridster'

//#endregion

import { default as apiModule, Api, LocalDictionaryFactory } from './../api/api.module'

import { default as commonModule, LoggerService } from './../common/common.module'
import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { UserSession, ConfigHelper } from '../../helpers'
import { OpOperator } from '../../models/core'
import { Activity, Enums } from '../../models/common'

import { DEPOSITORY_SERVICE_NAME, DepositoryService } from '../../services/depository'
import { SERVICES_MODULE_NAME } from './../../services/services.module'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService } from '../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../services/user-session'
import { GridContextMenuService, GRID_CONTEXT_MENU_SERVICE_NAME } from '../../services/grid'

import { DepositoryCreateEditDirective } from './create-edit/depositories-create-edit.directive'
import { DepositoryController, DepositoryScope } from './depositories.controller'
import { DepositoryDetailsDirective } from './details/depositories-details.directive'

import { DepositoryHelper } from './depositories.helper'

//#region Asset Imports

import * as TEMPLATE from './depositories.tpl.html'

//#endregion


// Consts

const CONTROLLER_NAME: string = 'DepositoriesController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'depositoryCreateEdit'
const DETAILS_DIRECTIVE_NAME: string = 'depositoryDetails'
const MENU_INDEX = 10
const MODULE_NAME: string = 'simax.depositories'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'DEPOSITORY_NAME'
const STATE_NAME: string = 'depositories'
const STATE_URL: string = '/depositories'

// Consts End


// Setup

const module = angular.module(MODULE_NAME, [commonModule, apiModule, 'gridster', SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME,
    $STATE_SERVICE_NAME,
    $TIMEOUT_SERVICE_NAME,
    'api',
    'logger',
    'localDictionary',
    GRID_CONTEXT_MENU_SERVICE_NAME,
    USER_SESSION_SERVICE_NAME,
    DEPOSITORY_SERVICE_NAME,
    SYSTEM_SERVICE_NAME,
    (
        $scope: DepositoryScope,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        logger: LoggerService,
        localDictionary: LocalDictionaryFactory,
        gridContextMenuService: GridContextMenuService,
        userSession: UserSessionService,
        depositoryService: DepositoryService,
        systemService: SystemService
    ) => new DepositoryController(
        $scope,
        $state,
        $timeout,
        api,
        logger,
        localDictionary,
        gridContextMenuService,
        userSession,
        depositoryService,
        systemService,
        DepositoryHelper.REFERENCE_TYPE,
        DepositoryHelper.SIMAX_MODULE_NAME
    )])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new DepositoryDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new DepositoryCreateEditDirective()])

module.config(['$stateProvider', 'userSessionProvider', SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Depository_IdLocation',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.DEPOSITORY_LIST)
                && !loggedOperator.hasPermission(Activity.DEPOSITORY_MODULE_HIDDEN_UI_OBJECT_PROPERTIES, Enums.UIObjectProperties.DepositoryModule)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.STORAGE),
                    'depositories',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    MENU_INDEX
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

// Setup End


export default MODULE_NAME